import { Component, OnDestroy, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthserviceService } from '../../core/services/authservice.service';
import { ChatUnreadSessionService } from '../../core/services/chat-unread-session.service';

@Component({
    selector: 'app-cliente-layout',
    templateUrl: './cliente-layout.component.html',
    styleUrls: ['./cliente-layout.component.css'],
    standalone: false
})
export class ClienteLayoutComponent implements OnInit, OnDestroy {
  readonly spinnerName = 'clienteLayoutSpinner';
  isSidebarCollapsed = false;
  private sidebarMql?: MediaQueryList;
  private sidebarMqlListener?: (event: MediaQueryListEvent) => void;

  constructor(
    private spinner: NgxSpinnerService,
    private authservice: AuthserviceService,
    private chatUnreadSession: ChatUnreadSessionService
  ) {}

  get userName(): string {
    return this.authservice.usuarioValue?.usuario ?? 'Usuario';
  }

  toggleSidebar(): void {
    this.isSidebarCollapsed = !this.isSidebarCollapsed;
  }

  ngOnInit(): void {
    this.chatUnreadSession.start();
    this.spinner.show(this.spinnerName);
    setTimeout(() => this.spinner.hide(this.spinnerName), 0);
    if (typeof window !== 'undefined') {
      this.sidebarMql = window.matchMedia('(max-width: 900px)');
      this.isSidebarCollapsed = this.sidebarMql.matches;
      this.sidebarMqlListener = (event: MediaQueryListEvent) => {
        this.isSidebarCollapsed = event.matches;
      };
      this.sidebarMql.addEventListener('change', this.sidebarMqlListener);
    }
  }

  ngOnDestroy(): void {
    this.chatUnreadSession.stop();
    if (this.sidebarMql && this.sidebarMqlListener) {
      this.sidebarMql.removeEventListener('change', this.sidebarMqlListener);
    }
  }
}
